import { Spinner, SpinnerSize } from "@fluentui/react";
import { LoadingGraphicContainer, SpanLoadingGraphic, SpanSubtitleLoadingGraphic } from "../Styles/SummaryPortfolioModelStyles";
import { ILoadingGraphicComponentProps } from "../Interfaces/SummaryPortfolioInterfaces";

const LoadingGraphicComponent = (props: ILoadingGraphicComponentProps) =>
{
    const { isLoading, noDataAvailable, noChartDataOnly, selectedOptions } = props;

    if(isLoading)
    {
        return(
            <LoadingGraphicContainer>
                <Spinner size={SpinnerSize.large} />
                <span>Cargando datos de la cartera...</span>
            </LoadingGraphicContainer>
        );
    }
    else if(noDataAvailable && selectedOptions.length === 1)
    {
        return(
            <LoadingGraphicContainer style={{color: '#666'}}>
                <SpanLoadingGraphic>No hay datos asociados a esa Cartera</SpanLoadingGraphic>
                <SpanSubtitleLoadingGraphic>Selecciona otra cartera modelo para ver su información.</SpanSubtitleLoadingGraphic>
            </LoadingGraphicContainer>
        );
    }
    else if(noChartDataOnly && selectedOptions.length === 1)
    {
        return(
            <LoadingGraphicContainer style={{color: '#666'}}>
                <SpanLoadingGraphic>No hay datos de gráfica para esta Cartera</SpanLoadingGraphic>
                <SpanSubtitleLoadingGraphic>La información de la tabla está disponible más abajo.</SpanSubtitleLoadingGraphic>
            </LoadingGraphicContainer>
        );
    }

    return null;
}

export default LoadingGraphicComponent;